<template>
    <HomeLayoutBack v-bind="layoutConfig">
        <BackButtonDesktop @clickBack="clickBack()"></BackButtonDesktop>
        <div v-if="campaign != null" class="flex flex-col lg:flex-row min-w-0 gap-4 lg:gap-8 max-w-6xl mx-auto py-6">
            <div class="lg:flex-auto text-a-brown-502314">
                <div class="px-4 lg:p-0">
                    <Picture :campaign="campaign" :rounded="false"></Picture>
                </div>
                <div class="border-b border-a-brown-d7c7b8 pb-4 mt-3 lg:mt-6 flex items-center">
                    <div class="text-base lg:text-24 font-main font-bold flex-auto px-4 lg:px-0">
                        {{ campaign.name }}
                    </div>
                    <div class="flex-none pr-4 lg:pr-0 leading-none">
                        <ButtonFavorite />
                    </div>
                </div>
                <div class="hidden lg:block mt-4">
                    <div class="text-14 lg:text-base font-main font-bold mb-2">
                        {{ lbl.detail.detail }}
                    </div>
                    <div class="text-14 lg:text-base font-main" v-html="campaign.detail"></div>
                </div>
            </div>
            <div class="lg:flex-none lg:w-456px">
                <div class="px-4 lg:border border-a-brown-d7c7b8 lg:rounded-20 lg:pb-6">
                    <ProductOptionsBuilder ref="optionsBuilder" 
                    :campaign="campaign" 
                    :selectedOptions="selectedOptions"
                    :subscriptionItem="subscriptionItem">
                    </ProductOptionsBuilder>
                    <ButtonAddToBag :enable="isEnableBtnAdd" :subscriptionItem="subscriptionItem" @onClickAdd="onClickAddToBag()"></ButtonAddToBag>
                </div>

                <div class="lg:hidden mx-4 border-t border-a-brown-d7c7b8 pt-4 mb-24 lg:mb-0">
                    <div class="text-14 font-main font-bold mb-2 text-a-brown-502314">
                        {{ lbl.detail.detail }}
                    </div>
                    <div class="text-14 text-a-brown-502314 font-main" v-html="campaign.detail"></div>
                </div>
            </div>
        </div>
    </HomeLayoutBack>
</template>
<script>
import { inject, onMounted, provide, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import ModalMixin from "@/mixin/ModalMixin.js";

// composable
import useProductDetail from '../composable/useProductDetail';
import useCartService from '../composable/useCartService';
import useErrorModal from '@/helper/composable/modal/useErrorModal';
import useLoadingModal from '@/helper/composable/modal/useLoadingModal';

// component
import HomeLayoutBack from '@/components/Layout/Page/HomeLayoutBack.vue'
import BackButtonDesktop from '@/components/Button/BackButtonDesktop.vue'
import Picture from '@/module/Detail/component/Picture.vue';
import ButtonFavorite from "../component/ButtonFavorite.vue"
import ProductOptionsBuilder from '../component/OptionBuilder/ProductOptionsBuilder.vue';
import ButtonAddToBag from '../component/ButtonAddToBag.vue'

// helper
import Utility from '@/helper/Utility';
import DatetimeHelper from '@/helper/DatetimeHelper';
import BKCart from '@/module/ShoppingCart/service/BKCart';

export default {
    name: 'ProductDetail',
    props: {},
    mixins: [ModalMixin],
    components: {
        HomeLayoutBack,
        BackButtonDesktop,
        Picture,
        ButtonFavorite,
        ProductOptionsBuilder,
        ButtonAddToBag,
    },
    computed: {
        layoutConfig: function () {
            return {
                showCart: true
            }
        }
    },
    setup: function () {
        //#region init
        const router = useRouter()
        const route = useRoute()
        const optionsBuilder = ref(null)
        const cartStore = inject("CartCountStore")
        const { lbl } = inject("LocaleStore")
        const modalStore = inject("ModalStore")
        const { showApiErrorModal, showErrorModal } = useErrorModal(modalStore)
        const { showLoadingModal, hideLoadingModal } = useLoadingModal(modalStore)
        const { init, campaign, selectedOptions, isEditMode, events , subscriptionItem } = useProductDetail()
        const cartService = useCartService()
        const price = ref(0)
        const priceBeforeDiscount = ref(0)
        const homeStore = inject("HomeStore")
        const isEnableBtnAdd = ref(true)
        const tracking = inject('trackingService');
        const subscriptionSelected = ref(false)

        // Setup Tracking
        tracking.screenName('menu detail');
        tracking.event('menu detail','view_menu_detail',null,null)

        console.log(tracking);
        events.onLoading = showLoadingModal
        events.onLoaded = hideLoadingModal
        events.onSuccess = ()=> {
            checkDisable();
        };
        events.onError = (err) => {
            showApiErrorModal(err);
        }

        const checkDisable = function () {
            homeStore.methods.init();
            homeStore.methods.initStatus().subscribe(() => {
                for (let item of homeStore.state.categoryPopup) {
                    if (campaign.value.categoryID == item.id) {
                        isEnableBtnAdd.value = DatetimeHelper.isBetweenTime(item.startTime,item.endTime);
                        console.log(isEnableBtnAdd.value,"start ",item.startTime,"end ",item.endTime);
                    }
                }
            });
        }


        //#endregion

        //#region methods

        const apiAddToCart = function () {
            // Call Tracking Event
            trackingEvent();

            let params = optionsBuilder.value.getParams()
            console.log("add to cart params", params)

            cartService.apiAddToCart(params).subscribe({
                next: () => {
                    hideLoadingModal()
                    // console.log(res);
                    cartStore.methods.updateCartCount()
                    if (isEditMode.value) {
                        // go to shopping cart page
                        router.replace({
                            name: "OrderSummary",
                            query: {
                                from: "builder"
                            }
                        })
                    }
                },
                error: (err) => {
                    hideLoadingModal()
                    if (err.code == 409 && err.id == 1403 && err.message == 'Quantity') {
                        showErrorModal(lbl.value.productDetail.err_more_then_40);
                    } else {
                        showApiErrorModal(err);
                    }

                }
            })
        }

        const onClickAddToBag = function () {
            showLoadingModal();

                if (isEditMode.value) {
                    // remove first
                    BKCart.apiDeleteCartItem(route.query.key).subscribe({
                        next: (res) => {
                            console.log(res)
                            apiAddToCart()
                        },
                        error: (err) => {
                            hideLoadingModal()
                            showApiErrorModal(err);
                        }
                    })
                } else {

                    apiAddToCart()
                }
        }

        const trackingEvent = function(){
            let trakingLabel = optionsBuilder.value.getOptionLabel()

            let sidelabel = ""
            let addonlabel = ""
            let ingredientslabel = ""
            let addonIDArray = [];

            // Sidedish and beverage label
            if(trakingLabel.trackingSideOther.length > 0){
                trakingLabel.trackingSideOther.forEach(sidedishData => {
                    sidelabel += `|${sidedishData}`
                });
            }

            // Addon label
            if(trakingLabel.trackingSide.length > 0){
                addonlabel += '|';

                trakingLabel.trackingSide.forEach((addonData, index) => {
                    let addonQty = addonData.qty;
                    let addonCampaign = addonData.addon.name;
                    let addonCampaignID = addonData.addon.id;

                    // Check if addonId already exist don't add it because addon array structer
                    if(!addonIDArray.includes(addonCampaignID)){
                        // If addonId not exist add new one on label
                        if(addonQty > 1){
                            addonlabel += index == 0 ? `${addonCampaign}${addonQty}` : `_${addonCampaign}${addonQty}`;
                        }
                        else{
                            addonlabel += index == 0 ? `${addonCampaign}` : `_${addonCampaign}`;
                        }

                    addonIDArray.push(addonCampaignID);
                    }
                });
            }

            // Ingrediant label
            if(trakingLabel.ingredients.length > 0){
                ingredientslabel += '|';

                trakingLabel.ingredients.forEach(ingredientsData => {
                    let ingredientsName = ingredientsData.name_en;
                    ingredientslabel += `${ingredientsName}`
                });
            }

            tracking.event(
                'menu detail',
                'add_to_bag',
                `${campaign.value.id}|${campaign.value.nameEn}|${trakingLabel.trakingCampaign.name_en}${sidelabel}${addonlabel}${ingredientslabel}|${trakingLabel.qty}`
                );
            // "Label ex.\n\
            //     beef|regular_french_fires|beverage|5’’patty|tomato_ketchup|2 \n\
            //     Or \n\
            //     beef|regular_french_fires|beverage|5’’ patty2|3"

        }

        const initBuilder = function () {
            Utility.scrollTop()
            let rowKey = route.query?.key ?? null
            init(rowKey);
        }
        const clickBack = function () {
            router.back();
        }
        //#endregion

        //#region provides
        provide("Campaign", campaign)
        provide("PriceState", price)
        provide("PriceBeforeDiscountState", priceBeforeDiscount)
        provide("SubscriptionSelected", subscriptionSelected)
        //#endregion

        watch(() => route.query, () => {
            if (route.name == "product_detail") {
                initBuilder()
            }
        })

        onMounted(() => {
            initBuilder()
        })

        return {
            lbl,
            optionsBuilder,
            campaign,
            selectedOptions,
            price,
            priceBeforeDiscount,
            onClickAddToBag,
            clickBack,
            isEnableBtnAdd,
            subscriptionItem
        }
    },
}
</script>
